module.exports = __webpack_public_path__ + "img/4.62c823cf.png";